export default [
  {
    value: {
      system: 'http://snomed.info/sct',
      display: 'Labs',
      code: '11502-2'
    },
    label: 'Labs',
    level: '1'
  },
  {
    value: {
      system: 'http://snomed.info/sct',
      display: 'Imaging',
      code: '18748-4'
    },
    label: 'Imaging',
    level: '2'
  },
  {
    value: {
      system: 'http://snomed.info/sct',
      display: 'Pathology',
      code: '11526-1'
    },
    label: 'Pathology',
    level: '3'
  }
]
